import { useState } from 'react';
import Button from '@app/components/ui/button';
import { useModal } from '@app/components/modal-views/context';
import { MemberDto } from '@app/store/project/types';
import { useAppSelector } from '@app/store/hooks';
import { selectActiveOrganization, selectActiveProject } from '@app/store/active/slice';
import { useTranslation } from 'next-i18next';
import WarningIcon from '@app/components/icons/warning';

interface IRemoveMemberModal {
    member: MemberDto;
    handleMemberDeletion: () => void;
}

export default function RemoveMemberModal({ member, handleMemberDeletion }: IRemoveMemberModal) {
    const activeOrganization = useAppSelector(selectActiveOrganization);
    const activeProject = useAppSelector(selectActiveProject);
    const { closeModal } = useModal();
    const { t } = useTranslation(['modal', 'common']);
    const [isLoading, setIsLoading] = useState(false);
    return (
        <div className="flex w-full max-w-[500px] flex-col gap-6 rounded-xl bg-white ">
            <div className="flex flex-col items-center gap-6 px-6 py-4">
                <WarningIcon />
                <div className={'h4'}>{t('removeMember')}</div>
                <div className="flex flex-col items-center gap-2 text-center">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: t('areYouSureYouWantToRemoveMember', {
                                email: member.userInfo.email,
                                name: member.projectId ? activeProject?.projectName : activeOrganization?.name
                            })
                        }}
                        className="p2 font-normal text-gray-500"
                    ></p>
                </div>
            </div>
            <div className="grid w-full !max-w-[500px] grid-rows-2 gap-4 px-6 py-4 sm:grid-cols-2 sm:grid-rows-1 sm:gap-6">
                <Button className={'h-[45px]  w-full !border-gray-300 !bg-white  !text-gray-900 hover:!bg-gray-100 hover:!text-gray-900'} variant="outline" onClick={closeModal}>
                    {t('cancel', { ns: 'common' })}
                </Button>
                <Button
                    className={'h-[45px] w-full rounded-[4px] !bg-red-500 hover:!bg-red-600'}
                    variant={'solid'}
                    isLoading={isLoading}
                    data-testid="remove-member"
                    onClick={() => {
                        setIsLoading(true);
                        handleMemberDeletion();
                    }}
                >
                    {t('removeNow', { ns: 'common' })}
                </Button>
            </div>
        </div>
    );
}
